<template lang="pug">
  Wrapper.q-px-lg.q-py-xl
    h5.q-mb-xl Orders
    .container-fluid.bg-gray.q-mb-md.overflow-auto
      .row.items-center.q-col-gutter-md
        .col-sm-12.col-xl-4
          md-field.items-center
            label Name / Company / Keyword
            md-input(v-model='search')
            md-button.md-icon-button.md-primary
              md-icon search
        .col-sm-6.col-xl-2
          md-field
            label Show
            md-select(v-model='show')
              md-option(value='all') All
        .col-sm-6.col-xl-2
          md-field
            label Filter
            md-select(v-model='filter')
              md-option(value='sort') Sort
        .col-sm-6.offset-sm-3.offset-md-4.col-xl-4.offset-xl-0.q-gutter-md(:class='$q.screen.lt.xl && "q-mb-md"')
          q-btn(outline color="primary" icon="cached" label="reset" @click="resetSearch")
          q-btn(color="primary" label="keyword" @click="keywordModalIsOpen = true")
    DataTable(:columns='columns')
        md-table-row(v-for='order in orderList', :key='order.no')
          md-table-cell(md-numeric) {{ order.no }}
          md-table-cell
            span.text-action {{ order.account }}
          md-table-cell {{ order.userName }}
          md-table-cell {{ order.surName }}
          md-table-cell {{ order.company }}
          md-table-cell.text-center
            img(v-if='order.flagged' :src='getSourceFromAsset("icon_flagged.png")')
          md-table-cell {{ order.message | truncate(10) }}
          md-table-cell {{ order.time | formatDateTime }}
          md-table-cell
            span.text-action(@click='openMessageContentModal(order)') Read
    Modal(
      isForm
      modalTitle='Keywords'
      submitButtonText='Search'
      :showModal='keywordModalIsOpen'
      :handleCloseModal='closeKeywordModal'
      :handleFormSubmit='keywordSearch')
      .flex.column.items-center.justify-center
        md-field.items-center
          md-input(v-model='keyword' placeholder='Enter a new keyword')
          md-button.md-icon-button.md-primary(@click='keywordSearch')
            md-icon search
        .flex.wrap.justify-center
          .tag(v-for='(tag, idx) in keywordTags' :key='tag')
            span.q-ml-sm.text-muted {{ tag }}
            md-button.md-icon-button.q-ma-none.q-mr-xs(@click='deleteTag(idx)')
              md-icon clear
    Modal(
      modalTitle='Detailed Message Content'
      :showModal='messageContentModal.isOpen'
      :handleCloseModal='closeMessageContentModal')
      .row
        .col-4.q-mb-md
          span.text-muted.q-mr-sm Account:
          span {{ messageContentModal.content.account }}
        .col-4.q-mb-md
          span.text-muted.q-mr-sm Type:
          span {{ messageContentModal.userType || 'User' }}
        .col-4.q-mb-md.flex
          span.text-muted.q-mr-sm Flagged:
          img(
            v-if='messageContentModal.content.flagged'
            :src='getSourceFromAsset("icon_flagged.png")')
          span(v-else) No
      .row
        .col-4.q-mb-md
          span.text-muted.q-mr-sm Name:
          span {{ messageContentModal.content.userName }}
        .col-4.q-mb-md
          span.text-muted.q-mr-sm Surname:
          span {{ messageContentModal.content.surName }}
      .row
        .col-4.q-mb-md
          span.text-muted.q-mr-sm Company:
          span {{ messageContentModal.content.company }}
        .col-4.q-mb-md
          span.text-muted.q-mr-sm Time/Date:
          span {{ messageContentModal.content.time | formatDateTime }}
      .row
        .col-12
          span.text-muted Message Content:
          md-field
            md-textarea.custom-textarea(v-model='messageContentModal.content.message')
      template(v-slot:dialog-actions)
        md-button Censor / Delete
        md-button.md-raised.md-primary Save
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import DataTable from '@/components/DataTable.vue';
import Modal from '@/components/Modal.vue';
import { getSourceFromAsset } from '@/utils';
import formatDateMixin from '@/utils/mixins/formatDateMixin';

const fake = {
  account: '13800138000',
  userName: 'Martin',
  surName: 'Xu',
  company: 'Coortrine Express Co.,Ltd',
  flagged: true,
  message:
    'Hi, this is message content sent by customer to transporter but i have to write more to be able to truncate',
  time: Date.now(),
};

export default {
  components: { Wrapper, DataTable, Modal },

  mixins: [formatDateMixin],

  data() {
    return {
      orderList: [],
      search: '',
      show: 'all',
      filter: 'sort',
      keywordModalIsOpen: false,
      keyword: '',
      keywordTags: [
        'account',
        'surname',
        'company',
        'time',
        'message content',
        'user name',
        'very long keyword',
      ],
      messageContentModal: {
        isOpen: false,
        content: {},
      },
    };
  },

  computed: {
    columns() {
      return [
        {
          name: 'no',
          isNumeric: true,
        },
        'account',
        'user name',
        'surname',
        'user company',
        'flagged',
        'message content',
        'order time',
        'operation',
      ];
    },
  },

  created() {
    for (let i = 0; i < 10; i += 1) {
      this.orderList.push({
        no: i,
        ...fake,
      });
    }
  },

  methods: {
    getSourceFromAsset,
    resetSearch() {
      this.search = '';
      this.show = 'all';
      this.filter = 'sort';
    },
    closeKeywordModal() {
      this.keywordModalIsOpen = false;
      this.keyword = '';
    },
    keywordSearch() {
      /* TODO: Implementation */
      this.closeKeywordModal();
    },
    deleteTag(tagIndex) {
      this.keywordTags.splice(tagIndex, 1);
    },
    openMessageContentModal(content) {
      this.messageContentModal = {
        isOpen: true,
        content,
      };
    },
    closeMessageContentModal() {
      this.messageContentModal = {
        isOpen: false,
        content: {},
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 1rem 1rem 0;
  border: 1px solid #dedede;
  border-radius: 4px;
  cursor: default;

  &:hover {
    background-color: #efefef;
  }
}

.custom-textarea {
  width: 550px;
  height: 12vw;

  @media screen and (min-width: 64em) {
    width: 650px;
  }

  @media screen and (min-width: 75em) {
    width: 750px;
  }
}
</style>
